/* Own outbound link. No network calls, storage, consent setters or provider code. */
(() => {
  'use strict';
  const button = document.querySelector('[data-bw-whatsapp]');
  if (!button) return;
  const gap = 12;
  const criticalSelector = '.maison-cookie:not([hidden]),[data-cookie-banner],#cookie-banner,#wbeu-trigger,button,input:not([type="hidden"]),select,textarea,[role="button"],.cart-line-actions,[data-mobile-controls],[data-upload-lift],a[data-upload-preview],a[href*="/checkout"]';
  let controls = [], provider = false;
  let frame = 0;
  const probe = document.createElement('span');
  probe.setAttribute('aria-hidden', 'true');
  probe.style.cssText = 'position:fixed;visibility:hidden;pointer-events:none;width:0;height:0;padding:env(safe-area-inset-top,0px) env(safe-area-inset-right,0px) env(safe-area-inset-bottom,0px) env(safe-area-inset-left,0px)';
  document.body.append(probe);
  const visible = node => {
    const r = node.getBoundingClientRect(), s = getComputedStyle(node);
    return !node.hidden && r.width > 0 && r.height > 0 && s.display !== 'none' && s.visibility !== 'hidden';
  };
  const providerPresent = () => !!window.wwhatsappJs || !!document.querySelector('#pushdaddy-widget,#pushdaddy-button,script[src*="pushdaddy_v42"]') ||
    [...document.scripts].some(script => {
      if (script.src) return false;
      const match = script.textContent.match(/\bvar urls\s*=\s*(\[[^;]+\]);/);
      if (!match) return false;
      try { return JSON.parse(match[1]).some(url => typeof url === 'string' && url.includes('/files/pushdaddy_v42.js')); }
      catch { return false; }
    });
  function place() {
    frame = 0;
    const overlay = document.querySelector('#wbeu-overlay');
    if (provider || window.wwhatsappJs || document.querySelector('dialog[open]') || overlay && visible(overlay)) { button.hidden = true; return; }
    button.hidden = false;
    const viewport = window.visualViewport, safe = getComputedStyle(probe);
    const leftEdge = (viewport?.offsetLeft || 0) + (parseFloat(safe.paddingLeft) || 0) + 8;
    const rightEdge = (viewport?.offsetLeft || 0) + (viewport?.width || innerWidth) - (parseFloat(safe.paddingRight) || 0) - 8;
    const topEdge = (viewport?.offsetTop || 0) + (parseFloat(safe.paddingTop) || 0) + 2;
    const bottomEdge = (viewport?.offsetTop || 0) + (viewport?.height || innerHeight) - (parseFloat(safe.paddingBottom) || 0) - gap;
    const candidate = document.querySelector('#wbeu-trigger.wbeu__trigger');
    const anchor = candidate && visible(candidate) && getComputedStyle(candidate).position === 'fixed' ? candidate.getBoundingClientRect() : null;
    const inView = anchor && anchor.top < bottomEdge && anchor.bottom > topEdge && anchor.left < rightEdge && anchor.right > leftEdge;
    const {width, height} = button.getBoundingClientRect();
    const preferredLeft = Math.max(leftEdge, Math.min(rightEdge, inView ? anchor.right : rightEdge) - width);
    const preferredTop = Math.min(bottomEdge - height, inView ? anchor.top - gap - height : bottomEdge - height);
    const obstacles = controls.filter(visible).map(node => node.getBoundingClientRect()).filter(r => r.bottom > topEdge && r.top < bottomEdge);
    let left = preferredLeft, top = topEdge - height;
    // Ordinary product/navigation links do not displace this contact control.
    // Four pixels around other controls; only a constrained viewport may use edge contact.
    for (const clearance of [4, 0]) {
      const columns = new Set([preferredLeft, rightEdge - width, leftEdge, ...obstacles.flatMap(r => [r.left - width - clearance, r.right + clearance])]);
      for (const x of columns) {
        if (x < leftEdge || x + width > rightEdge) continue;
        let y = preferredTop;
        for (let pass = 0; pass <= obstacles.length; pass++) {
          let next = y;
          for (const r of obstacles) if (x < r.right + clearance && x + width > r.left - clearance && y < r.bottom + clearance && y + height > r.top - clearance) next = Math.min(next, r.top - clearance - height);
          if (y === next) break;
          y = next;
        }
        if (y >= topEdge) { left = x; top = y; break; }
      }
      if (top >= topEdge) break;
    }
    if (!width || !height || top < topEdge || left + width > rightEdge) { button.hidden = true; return; }
    button.style.setProperty('--bw-wa-left', left + 'px');
    button.style.setProperty('--bw-wa-top', top + 'px');
    button.setAttribute('data-bw-positioned', '');
  }
  function schedule() { if (!frame) frame = requestAnimationFrame(place); }
  const resize = new ResizeObserver(schedule);
  resize.observe(button);
  const observed = new WeakSet();
  function observeObstacles() {
    controls = [...document.querySelectorAll(criticalSelector)].filter(node => node !== button && !button.contains(node));
    provider = providerPresent();
    document.querySelectorAll('[data-bw-whatsapp]').forEach(node => { if (node !== button && !node.hidden) node.hidden = true; });
    for (const node of controls) if (!observed.has(node)) { observed.add(node); resize.observe(node); }
  }
  new MutationObserver(records => {
    const external = records.filter(record => record.target !== button && record.target !== probe && !button.contains(record.target));
    if (external.some(record => record.type === 'childList' && ([...record.addedNodes, ...record.removedNodes].some(node => node.nodeType === 1) || record.target.tagName === 'SCRIPT') || record.attributeName === 'src' || record.attributeName === 'hidden')) observeObstacles();
    if (external.length) schedule();
  }).observe(document.documentElement, {subtree:true, childList:true, attributes:true, attributeFilter:['hidden','open','class','style','src']});
  window.addEventListener('scroll', schedule, {passive:true});
  window.addEventListener('resize', schedule);
  window.visualViewport?.addEventListener('resize', schedule);
  window.visualViewport?.addEventListener('scroll', schedule);
  document.fonts?.ready.then(schedule);
  observeObstacles();
  place();
})();
